


import ImpresoraService from '@/api/servicios/ImpresoraService'
import ComandaService from '@/api/servicios/ComandaService'
import store from '@/store'
import Vue from 'vue'
import funciones from './funciones'
"use strict";

class Fiscalizar {

    cargando = false
    MonedaPais = {}
    configuracion = {
        igtf: 3
    }

    round = num => {
        var m = Number((Math.abs(num) * 100).toPrecision(15))
        return (Math.round(m) / 100) * Math.sign(num)
    }
    imprimirDocumentoNoFiscal = async (pLineas, impresora) => {
        await ImpresoraService.imprimirNoFiscal(pLineas, impresora)
            .then(response => {
                store.commit('setAlert', {
                    message: `Impresion tiket no fiscal`,
                    type: 'success',
                })
            })
            .catch(error => {
                store.commit('setAlert', {
                    message: `error Impresion tiket no fiscal`,
                    type: 'error',
                })
            })
    }


    errorFiscal = async (facturas, ind_devolucion = false) => {

        

        await Vue.swal({
            icon: 'warning',
            html:
                '<h3>¿Hubo un error, la factura se emitio? </h3>' +
                ` ` +
                ` 
                    <input style="    id="swal-motivo-anulacion"   class="swal2-input" placeholder="Numero ${ind_devolucion ? 'Factura' : 'Nota de Credito'}">  `,
            showCancelButton: true,
            confirmButtonText: 'Si, Seguro',
            showLoaderOnConfirm: true,
            cancelButtonText: 'No',
            preConfirm: async () => {
                const numero = document.getElementById('swal-motivo-anulacion').value

                if (numero != undefined && numero != '' && numero != null && !isNaN(numero)) {
                    await this.facturaNuevo({
                        ...facturas,
                        numero_control: numero,
                        serial_impresora: this.serialFiscal,
                    })

                    if (facturas._servicio && !ind_devolucion) {
                        if (Number(facturas._servicio.pvp) > 0) {
                            this.imprimirDocumentoNoFiscal(
                                'Total Venta:           Bs ' +
                                Number(facturas.total).toFixed(2) +
                                ';Total Servicio (10%)  Bs ' +
                                Number(facturas._servicio.pvp).toFixed(2) +
                                ';Total:                Bs ' +
                                (Number(facturas.total) + Number(facturas._servicio.pvp)).toFixed(2),
                                store.state.impresoraFiscal,
                            )
                        }
                    }
                    return true
                } else {
                    Vue.swal.showValidationMessage(`Debe proporcionar un numero valido`)
                }
            },
            allowOutsideClick: () => {
                !Vue.swal.isLoading()
            },
        }).then(result => {
            //GetFiscalizando(false)
        })
    }

    facturaNuevo = async facturas => {
        await ComandaService.nuevaFactura(facturas)
            .then(response => {
                try {
                    if (response.data.mensaje == 'FACTURA GUARDADA CON EXITO') {
                        store.commit('setAlert', {
                            message: `factura registrada con exito: ${facturas.numero_control}`,
                            type: 'success',
                        })
                    } else {
                        store.commit('setAlert', {
                            message: `Verificar si se realizo la factura: ${facturas.numero_control}`,
                            type: 'warning',
                        })
                    }

                } catch (error) {
                    store.commit('setAlert', {
                        message: `hubo un error: ${error}`,
                        type: 'error',
                    })
                }
            })
            .catch(error => {
                store.commit('setAlert', {
                    message: `Disculpe hubo un error: ${error}`,
                    type: 'error',
                })
            })
    }
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    Fiscalizar = async (_props = {
        item,
        _MonedaPais,
        _serialFiscal,
        _ind_devolucion: false
    }
    ) => {

        this.cargando = true
        this.ind_devolucion = _props._ind_devolucion
        this.MonedaPais = _props._MonedaPais // {id:2,tasa:29.10}  
        this.serialFiscal = _props._serialFiscal
        this.comandaFiscalizada = { ..._props.item, devolucion_value: _props._ind_devolucion }



        if (!this.ind_devolucion) {
            await ComandaService.listarComandaAgrupado({ id: _props.item.id })
                .then(async response => {
                    console.log(response)
                    if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
                        await this.Totalizar(response.data.datos)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        } else {
            await ComandaService.listarFacturaLmpresora({ id: _props.item.id })
                .then(async response => {

                    if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
                        await this.DevolverFactura(response.data.datos)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        }

    }

    DevolverFactura = async datos => {
        const impresora = { ...store.state.impresoraFiscal }
        const factura = {
            ...datos,
            nFactura: datos.nFactura.toString(),
            montoRecDesc: datos.montoRecDesc.toString(),
            impresora: { ...impresora },
        }
        await ImpresoraService.imprimirFactura({
            factura: factura, pIsDevolucion: true, pAbrirGaveta: false,
            indIgtf: funciones.configuracionSelect(2) > 0 ? true : false,
        })
            .then(async response => {
                try {
                    if ((response.data.estatus = true)) {
                        if (Number(response.data.datos.lastDocument) > 0) {
                            await this.facturaNuevo({
                                ...factura,
                                numero_control: response.data.datos.lastDocument,
                                serial_impresora: this.serialFiscal,
                            })
                        } else {
                            await this.errorFiscal({
                                ...factura,
                                serial_impresora: this.serialFiscal,
                            })
                        }
                    } else {
                        await this.errorFiscal({
                            ...factura,
                            serial_impresora: this.serialFiscal,
                        })
                    }

                } catch (error) {
                    await this.errorFiscal({
                        ...factura,
                        serial_impresora: this.serialFiscal,
                    })
                }
            })
            .catch(error => {
                store.commit('setAlert', {
                    message: `Disculpe hubo un error: ${error}`,
                    type: 'error',
                })
                console.log(error)
            })
    }

    Totalizar = async item => {
        this.comandaFiscalizada = item
        let descuento = 0.0
        let servicio = 0.0
        let iva = 0.0
        let igtf = 0.0
        let subtotal = 0.0
        let total = 0.0
        let resta = 0.0
        let totalPagos = 0.0

        let descuentoMonedaPais = 0.0
        let servicioMonedaPais = 0.0
        let ivaMonedaPais = 0.0
        let igtfMonedaPais = 0.0
        let subtotalMonedaPais = 0.0
        let totalMonedaPais = 0.0
        let restaMonedaPais = 0.0
        let totalPagosMonedaPais = 0.0
        let totalPagosMoneda = 0.0
        let RecargoivaMonedaPais = 0.0
        let RecargoIva = 0.0
        let RecargoMonedaPais = 0.0
        let Recargo = 0.0

        this.comandaFiscalizada.productos.forEach(element => {
            const PrecioRealMonedaPais_ = this.round(element.precio_real * this.MonedaPais.tasa)
            const PrecioTotalMonedaPais_ = this.round(PrecioRealMonedaPais_ * element.cantidad)
            const descuentoMonedaPais_ = this.round(PrecioTotalMonedaPais_ * (element.por_descuento / 100))
            let recargoMonedaPais_ =
                (PrecioTotalMonedaPais_ - descuentoMonedaPais_) * (this.comandaFiscalizada.por_comision / 100)
            const ivaMonedaPais_ =
                (PrecioTotalMonedaPais_ - descuentoMonedaPais_) * (element.producto.impuesto_tasa_valor / 100)

            subtotalMonedaPais += PrecioTotalMonedaPais_
            descuentoMonedaPais += descuentoMonedaPais_
            ivaMonedaPais += ivaMonedaPais_
            RecargoMonedaPais += recargoMonedaPais_

            const PrecioReal_ = this.round(element.precio_real)
            const PrecioTotal_ = this.round(PrecioReal_ * element.cantidad)
            const descuento_ = this.round(PrecioTotal_ * (element.por_descuento / 100))

            let recargo_ = this.round((PrecioTotal_ - descuento_) * (this.comandaFiscalizada.por_comision / 100))
            const iva_ = this.round((PrecioTotal_ - descuento_) * (element.producto.impuesto_tasa_valor / 100))
            descuento += descuento_
            iva += iva_
            subtotal += PrecioTotal_
            Recargo += recargo_
        })

        this.comandaFiscalizada.pagos.forEach(element => {
            if (element.monto > 0) {
                const totalPagosMonedaPais_ = Number((Number(element.monto_real) * this.MonedaPais.tasa).toFixed(2))
                const totalPagos_ = Number(Number(element.monto_real).toFixed(2))
                const totalPagosMoneda_ = Number(Number(element.monto_moneda).toFixed(2))

                const igtfMonedaPais_ = Number((Number(Number(element.igtf)) * this.MonedaPais.tasa).toFixed(2))
                const igtf_ = Number(Number(element.igtf).toFixed(2))

                totalPagosMonedaPais += totalPagosMonedaPais_
                totalPagos += totalPagos_
                totalPagosMoneda += totalPagosMoneda_
                igtfMonedaPais += igtfMonedaPais_
                igtf += igtf_
            }
        })
        servicioMonedaPais = this.round(RecargoMonedaPais)
        totalMonedaPais = this.round(
            subtotalMonedaPais - descuentoMonedaPais + ivaMonedaPais + igtfMonedaPais, // + servicioMonedaPais,
        )
        restaMonedaPais = this.round(totalMonedaPais - totalPagosMonedaPais)

        servicio = this.round(Recargo)
        total = this.round(subtotal - descuento + iva + igtf + servicio)
        resta = total - totalPagos
        console.log('servicio aquii')
        console.log(this.round((subtotal - descuento) * (this.comandaFiscalizada.por_comision / 100)))

        let diferencia = this.round(total * this.MonedaPais.tasa - totalMonedaPais)



        servicioMonedaPais = this.round(
            (subtotalMonedaPais - descuentoMonedaPais) * (this.comandaFiscalizada.por_comision / 100),
        )

        totalMonedaPais = this.round(
            subtotalMonedaPais - descuentoMonedaPais + ivaMonedaPais + igtfMonedaPais, //+ servicioMonedaPais,
        )
        restaMonedaPais = this.round(totalMonedaPais - totalPagosMonedaPais)

        this.comandaFiscalizada = {
            ...this.comandaFiscalizada,
            descuento,
            servicio,
            iva,
            igtf,
            total,
            totalPagos,
            resta,
            subtotal,
            descuentoMonedaPais,
            servicioMonedaPais,
            ivaMonedaPais,
            igtfMonedaPais,
            subtotalMonedaPais,
            totalMonedaPais,
            restaMonedaPais,
            totalPagosMonedaPais,
            diferencia,
            RecargoMonedaPais,
            Recargo,
        }
        let devolucion = {}
        if (this.comandaFiscalizada.factura != null) {
            devolucion = {
                nFacturaAfectada: this.comandaFiscalizada.id.toString(),
                numControlContraDev: this.comandaFiscalizada.factura.numero_control,
                fechaFactContDev: new Date(),
                serialFactContDev: '',
            }
        }
        let ctdProductos = 0
        this.comandaFiscalizada.productos.forEach(item => {
            ctdProductos += item.cantidad
        })
        let factura = {
            nFactura: this.comandaFiscalizada.id.toString(),
            cajero: this.comandaFiscalizada.comandero_nombre,
            ctdProductos: Number(ctdProductos.toFixed(2)),
            sub_total: this.comandaFiscalizada.subtotalMonedaPais, //+ this.comandaFiscalizada.servicioMonedaPais + diferencia,
            recargo: '0', //this.comandaFiscalizada.servicioMonedaPais,
            descuento: this.comandaFiscalizada.descuentoMonedaPais,
            igtf: this.comandaFiscalizada.igtfMonedaPais,
            total: this.comandaFiscalizada.totalMonedaPais, //+ diferencia,
            total_pago: this.comandaFiscalizada.totalPagosMonedaPais,
            vuelto: this.comandaFiscalizada.totalPagosMonedaPais - this.comandaFiscalizada.totalMonedaPais,
            iva: this.comandaFiscalizada.ivaMonedaPais,
            montoRecDesc: '0', //Number(this.comandaFiscalizada.servicioMonedaPais).toFixed(2).toString(),
            isPorcentajeRecDesc: false,
            isRecDesc: true,
            cliente: {
                id_cliente: this.comandaFiscalizada.id_cliente,
                direccion: this.comandaFiscalizada.direccion_cliente,
                nombre:
                    this.comandaFiscalizada.id_cliente == null
                        ? this.comandaFiscalizada.cliente
                        : [3, 4, 5].includes(this.comandaFiscalizada.id_tipo_cliente)
                            ? this.comandaFiscalizada.nombre_cliente + ' ' + this.comandaFiscalizada.apellido_cliente
                            : this.comandaFiscalizada.nombre_cliente,
                cedula: this.comandaFiscalizada.id_cliente == null ? '12345679' : this.comandaFiscalizada.documento,
            },
            impresora: { ...store.state.impresoraFiscal },
        }

        let producto = []

        this.comandaFiscalizada.productos.forEach(item => {
            producto.push({
                id_producto: item.producto.id,
                barra: item.producto.id.toString(),
                descripcion: item.producto.nombre,
                pvp: (item.precio_real * this.MonedaPais.tasa).toFixed(2),
                cantidad: item.cantidad.toFixed(2),
                sub_total: (item.sub_total * this.MonedaPais.tasa).toFixed(2),
                descuento: (item.descuento * this.MonedaPais.tasa).toFixed(2),
                iva_total: (item.iva * this.MonedaPais.tasa).toFixed(2),
                total: (item.total * this.MonedaPais.tasa).toFixed(2),
                IVA: item.producto.impuesto_tasa_valor.toFixed(2),
                descuento: (item.descuento * this.MonedaPais.tasa).toFixed(2),
                serial: '',
            })
        })

        if (this.comandaFiscalizada.por_comision / 100 > 0) {
            factura = {
                ...factura,
                _servicio: {
                    id_producto: 99999,
                    barra: '99999',
                    descripcion: 'SERVICIO',
                    pvp: servicioMonedaPais.toFixed(2),
                    cantidad: '1',
                    sub_total: servicioMonedaPais.toFixed(2),
                    descuento: '0',
                    iva_total: '0',
                    total: servicioMonedaPais,
                    IVA: '0',
                    descuento: '0',
                    serial: '',
                },
            }
        }

        let pagosFacturas = []
        let sum = 0
        this.comandaFiscalizada.pagos.forEach((item, i) => {
            if (item.monto > 0) {
                if (sum < Number(this.comandaFiscalizada.totalMonedaPais)) {
                    sum +=
                        item.moneda.id != this.MonedaPais.id
                            ? Number(this.MonedaPais.tasa) * Number(item.monto_real)
                            : Number(item.monto_moneda)
                    0
                    pagosFacturas.push({
                        id_moneda: item.moneda.id,
                        descripcion: item.moneda.nombre,
                        igtf: (item.igtf * this.MonedaPais.tasa).toFixed(2),
                        monto:
                            item.moneda.id != this.MonedaPais.id
                                ? (this.MonedaPais.tasa * item.monto_real).toFixed(2)
                                : item.monto_moneda.toFixed(2),
                        tasa: item.moneda.tipo_pago[0].ind_igtf == true ? this.MonedaPais.tasa.toFixed(2) : '1.00',
                        formaPago: item.moneda.tipo_pago[0].id_fiscal,
                    })
                }
            }
        })
        let facturas = { ...factura, producto, pagosFacturas, devolucion_value: false }

        /* if (this.comandaFiscalizada.factura?.numero_control != undefined) {
             facturas = { ...facturas, devolucion: { ...devolucion }, devolucion_value: true }
         }*/

        await ImpresoraService.imprimirFactura({

            factura: facturas,
            pIsDevolucion: false,
            pAbrirGaveta: false,
            indIgtf: funciones.configuracionSelect(2) > 0 ? true : false,
        })
            .then(async response => {
                try {
                    if ((response.data.estatus = true)) {
                        if (Number(response.data.datos.lastDocument) > 0) {
                            await this.facturaNuevo({
                                ...facturas,
                                numero_control: response.data.datos.lastDocument,
                                serial_impresora: this.serialFiscal,
                            })

                            if (facturas._servicio) {
                                if (Number(facturas._servicio.pvp) > 0) {
                                    await this.imprimirDocumentoNoFiscal(
                                        'Total Venta:           Bs ' +
                                        Number(facturas.total).toFixed(2) +
                                        ';Total Servicio (10%)  Bs ' +
                                        Number(facturas._servicio.pvp).toFixed(2) +
                                        ';Total:                Bs ' +
                                        (Number(facturas.total) + Number(facturas._servicio.pvp)).toFixed(2),
                                        store.state.impresoraFiscal,
                                    )
                                }
                            }
                        } else {
                            await this.errorFiscal({
                                ...facturas,
                                serial_impresora: this.serialFiscal,
                            })
                        }
                    } else {
                        await this.errorFiscal({
                            ...facturas,
                            serial_impresora: this.serialFiscal,
                        })
                    }
                } catch (error) {
                    await this.errorFiscal({
                        ...facturas,
                        serial_impresora: this.serialFiscal,
                    })
                }
            })
            .catch(error => {
                store.commit('setAlert', {
                    message: `Disculpe hubo un error: ${error}`,
                    type: 'error',
                })
            })
    }

}
export default new Fiscalizar();